module.exports = __webpack_public_path__ + "static/img/banner2.d138906d.png";